import { useState } from 'react';

import { useAppSelector } from 'coreOld/hooks';
import { useGetCompanyPart } from 'partsOld/hooks';

import { RowTabs } from './constants';
import CompanyPartRowDetailsView from './CompanyPartRowDetailsView';

const tabs = [
  { title: RowTabs.DETAILS },
  { title: RowTabs.COSTING },
  { title: RowTabs.PRICING },
  { title: RowTabs.UOMS },
  { title: RowTabs.INVENTORY },
  { title: RowTabs.HISTORY },
];

const CompanyPartRowDetails = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const { selectedRow } = useAppSelector((state: any) => state.table);

  const { record, isLoading, isError } = useGetCompanyPart(
    {
      part: {
        number: selectedRow?.part,
        manufacturerId: selectedRow?.manufacturerId,
      },
    },
    selectedRow
  );

  return (
    <CompanyPartRowDetailsView
      selectedPart={record}
      tabs={tabs}
      setActiveTab={setActiveTab as any}
      activeTab={activeTab}
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export default CompanyPartRowDetails;
